import React, { useState } from 'react';
import { Button, Checkbox, FormControlLabel, Box, Grid } from '@mui/material';
import axios from 'axios';
import { APIURL } from '../../../../config'

export default function CustomerTasks({typeList, originalSelectedTaskTypes, originalDDIds, empId, comp_id, cusDets, edit, onSave}) {
    const [selectedTaskTypes, setSelectedTaskTypes] = useState(originalSelectedTaskTypes || []);
    const [selectedDDIds, setSelectedDDIds] = useState(originalDDIds || []);
    const [isSaving, setIsSaving] = useState(false);

    const handleCheckboxChange = (event, taskType) => {
        if (event.target.checked) {
            setSelectedDDIds((prev) => [...prev, taskType.ddID]);
            setSelectedTaskTypes((prev) => [...prev, taskType]);
        } else {
            setSelectedDDIds((prev) => prev.filter((ddID) => ddID !== taskType.ddID));
            setSelectedTaskTypes((prev) => prev.filter((type) => type.ddID !== taskType.ddID));
        }
    };

    const handleOnAdd = async () => {
        if (isSaving) {
            return;
        }

        setIsSaving(true);

        let uniqueDdIDs = new Set((originalSelectedTaskTypes || []).map(item => item.ddID));
        let taskTypesToInsert = selectedTaskTypes.filter(item => !uniqueDdIDs.has(item.ddID));

        let payload = {
            taskData: taskTypesToInsert,
            empid: empId,
            status: 1,
            comp_id,
            customer_id: cusDets.cus_id
        }

        let addResult = await axios.post(APIURL + "/customers/CustomerTasks", payload);

        let taskTypesToUpdate = originalSelectedTaskTypes.filter(itemA => {
            return !selectedTaskTypes.some(itemB => {
                return JSON.stringify(itemA.ddID) === JSON.stringify(itemB.ddID);
            });
        });

        let updatePayload = {
            taskData: taskTypesToUpdate,
            empid: empId,
            status: 1,
            comp_id,
            customer_id: cusDets.cus_id
        }

        let updateResult = await axios.delete(APIURL + "/customers/CustomerTasks", { data: updatePayload });

        setIsSaving(false);
    }

    // Combined handler for edit mode: save tasks then trigger parent form save
    const handleSaveTasksAndForm = async () => {
        await handleOnAdd();
        onSave();
    };

    return (
    <Box>
      <Box sx={{ mt: 2 }}>
        <p>Select the task types to associate with {cusDets?.cus_name || 'customer'}:</p>
      </Box>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {typeList.map((taskType) => (
          <Grid size={6} key={taskType.ddID}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedDDIds.includes(taskType.ddID)}
                  onChange={(event) => handleCheckboxChange(event, taskType)}
                />
              }
              label={taskType.EntityValue}
            />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Button variant="contained" fullWidth onClick={handleSaveTasksAndForm}>
           Save Customer
        </Button>
      </Box>
    </Box>
    );
}